/* @flow */

import * as React from 'react';

import useResizeObserver from '@react-hook/resize-observer';

// From https://www.npmjs.com/package/@react-hook/resize-observer
export default function useSize(target: {
  current: null | HTMLElement,
}): void | {
  width: number,
  height: number,
} {
  const [size, setSize] = React.useState<void | {
    width: number,
    height: number,
  }>(undefined);

  const verifyChanges = (newSize: { width: number, height: number }) => {
    setSize((prevState) => {
      const { width, height } = newSize;

      if (width === 0 || height === 0) return prevState;

      const shouldChangeState =
        !prevState || width !== prevState.width || height !== prevState.height;

      if (shouldChangeState) {
        return { width, height };
      }

      return prevState;
    });
  };

  React.useEffect(() => {
    if (target.current) {
      verifyChanges(target.current.getBoundingClientRect());
    }
  }, [target.current]);

  // Where the magic happens
  useResizeObserver(target, (entry) => verifyChanges(entry.contentRect));

  return size;
}
